import { useAppSelector } from '@app/hooks';
import { UserType } from '@features/api/response/User';
import { useUserQuery } from '@features/api/userSlice';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';

const userAndCompanyHolderRestrictedRoutes = ['crm', 'agents'];
const nomineeAgentRestrictedRoutes = ['agents'];

export const ProtectedRoute = () => {
  const { isAuthenticated, isEmailVerified, userType } = useAppSelector(
    (state) => state.auth
  );
  const { shutdown } = useIntercom();
  useUserQuery(undefined, {
    refetchOnFocus: true,
    skip: !isAuthenticated || !isEmailVerified,
  });

  const { pathname } = useLocation();
  useEffect(() => {
    if (!isAuthenticated) {
      shutdown();
    }
  }, [isAuthenticated, shutdown]);

  if (
    !isAuthenticated &&
    pathname !== '/email-verification' &&
    pathname !== '/email-verification-request'
  ) {
    return <Navigate to='/login' replace />;
  }

  if (
    isAuthenticated &&
    isEmailVerified === false &&
    pathname !== '/email-verification' &&
    pathname !== '/email-verification-request'
  ) {
    return <Navigate to='/email-verification' replace />;
  }

  if (
    (userType === UserType.User || userType === UserType.CompanyHolder) &&
    userAndCompanyHolderRestrictedRoutes.find((x) => pathname.includes(x))
  ) {
    return <Navigate to='/' replace />;
  }

  if (
    userType === UserType.NomineeAgent &&
    nomineeAgentRestrictedRoutes.find((x) => pathname.includes(x))
  ) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
};
